import React from 'react';

const Heading = ({ text, Icon }) => {
  return (
    <div className="flex items-center space-x-3 font-inter">
      {Icon && <Icon className="w-5 h-5" />}
      <h1 className="text-lg font-semibold text-gray-800">{text}</h1>
    </div>
  );
};

export default Heading;
